export default "__VITE_ASSET__fd315586__"